import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoginForm from '../components/Auth/LoginForm';
import OAuthButtons from '../components/Auth/OAuthButtons';

export default function LoginPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  // OAuth failures land here as ?error=<key>&error_description=…
  const oauthError = params.get('error_description') ?? params.get('error');

  return (
    <main style={{ maxWidth: 360, margin: '4rem auto', fontFamily: 'system-ui, sans-serif' }}>
      <h1>{t('auth.signIn')}</h1>
      <LoginForm onSignedIn={() => navigate('/account')} />
      <OAuthButtons />
      {oauthError && <p style={{ color: 'red' }}>{oauthError}</p>}
      <p>
        <Link to="/forgot-password">{t('auth.forgotPassword')}</Link>
      </p>
      <p>
        {t('auth.newHere')} <Link to="/register">{t('auth.createAccount')}</Link>
      </p>
    </main>
  );
}
